(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('siblings-faqs')) {
    customElements.define('siblings-faqs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        const items = [...this.querySelectorAll('details')];

        const collapse = (target, animated) => {
          if (target.dataset.animating) return;
          if (!animated) {
            target.open = false;
            return;
          }
          const targetSummary = target.querySelector('summary');
          const startHeight = target.offsetHeight;
          target.dataset.animating = 'true';
          target.style.height = `${startHeight}px`;
          const animation = target.animate(
            { height: [`${startHeight}px`, `${targetSummary.offsetHeight}px`] },
            { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }
          );
          animation.onfinish = () => {
            target.open = false;
            target.style.height = '';
            delete target.dataset.animating;
          };
          animation.oncancel = () => {
            target.style.height = '';
            delete target.dataset.animating;
          };
        };

        items.forEach((details) => {
          const summary = details.querySelector('summary');
          const answer = details.querySelector('.siblings-lp__answer');
          summary.addEventListener('click', (event) => {
            const isOpen = details.open;
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            if (reduceMotion) {
              if (!isOpen) {
                items.forEach((other) => {
                  if (other !== details && other.open) collapse(other, false);
                });
              }
              return;
            }

            event.preventDefault();
            if (details.dataset.animating) return;

            if (!isOpen) {
              items.forEach((other) => {
                if (other !== details && other.open) collapse(other, true);
              });
            }

            const startHeight = details.offsetHeight;
            if (!isOpen) details.open = true;
            const endHeight = isOpen ? summary.offsetHeight : summary.offsetHeight + answer.offsetHeight;
            details.dataset.animating = 'true';
            details.style.height = `${startHeight}px`;
            const animation = details.animate(
              { height: [`${startHeight}px`, `${endHeight}px`] },
              { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }
            );
            animation.onfinish = () => {
              if (isOpen) details.open = false;
              details.style.height = '';
              delete details.dataset.animating;
            };
            animation.oncancel = () => {
              details.style.height = '';
              delete details.dataset.animating;
            };
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-final-cta]');
    root?.querySelectorAll('.siblings-lp__button[href^="#"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = document.querySelector(button.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hp-hero-upgrade')) {
    customElements.define('hp-hero-upgrade', class extends HTMLElement {
      connectedCallback() {
        if (this.hpInit) return;
        this.hpInit = true;

        // Every overlay reference is captured here, before open() portals the
        // overlay out of this element and into <body>.
        this.overlay = this.querySelector('[data-video-overlay]');
        if (!this.overlay) return;

        const partsData = this.querySelector('[data-hph-parts]');
        try {
          this.parts = partsData ? JSON.parse(partsData.textContent) : [];
        } catch (error) {
          this.parts = [];
        }
        if (!this.parts.length) return;

        this.players = [
          this.overlay.querySelector('[data-video-a]'),
          this.overlay.querySelector('[data-video-b]')
        ].filter(Boolean);
        if (!this.players.length) return;

        this.active = 0;   // which of this.players is on screen
        this.index = 0;    // which part that player is holding
        this.staged = false;
        this.primed = false;
        this.video = this.players[0];

        this.closeButton = this.overlay.querySelector('[data-video-close]');
        this.toggleButton = this.overlay.querySelector('[data-video-toggle]');
        this.muteButton = this.overlay.querySelector('[data-video-mute]');
        this.volumeInput = this.overlay.querySelector('[data-video-volume]');
        this.progress = this.overlay.querySelector('[data-video-progress]');
        this.bufferBar = this.overlay.querySelector('[data-video-buffer]');
        this.fillBar = this.overlay.querySelector('[data-video-fill]');
        this.knob = this.overlay.querySelector('[data-video-knob]');
        this.currentLabel = this.overlay.querySelector('[data-video-current]');
        this.durationLabel = this.overlay.querySelector('[data-video-duration]');

        this.measureTimeline();

        this.handleKeydown = (event) => {
          if (event.key === 'Escape') this.close();
        };

        this.querySelectorAll('[data-video-play]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.open(trigger));
        });

        if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());
        this.overlay.addEventListener('click', (event) => {
          if (event.target === this.overlay) this.close();
        });

        this.players.forEach((player) => {
          player.setAttribute('playsinline', '');
          player.addEventListener('play', () => { if (player === this.video) this.syncPlayState(); });
          player.addEventListener('pause', () => { if (player === this.video) this.syncPlayState(); });
          player.addEventListener('volumechange', () => { if (player === this.video) this.syncVolumeState(); });
          player.addEventListener('ended', () => { if (player === this.video) this.advance(); });
          player.addEventListener('timeupdate', () => {
            if (player !== this.video || this.scrubbing) return;
            this.renderProgress();
            const duration = player.duration;
            // start pulling the next part well before we need it
            if (isFinite(duration) && duration - player.currentTime < 25) this.stageNext();
          });
          player.addEventListener('loadedmetadata', () => {
            const part = this.parts[Number(player.dataset.part)];
            if (!part || !isFinite(player.duration)) return;
            // trust real metadata over the value Liquid reported
            if (Math.abs((part.duration || 0) - player.duration) > 0.5) {
              part.duration = player.duration;
              this.measureTimeline();
            }
          });
        });

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', () => {
            if (!this.video) return;
            this.prime();
            if (this.video.paused) {
              // finished the last part — pressing play starts the film over
              if (this.video.ended && this.index === this.parts.length - 1) this.rewindAll();
              const played = this.video.play();
              if (played && played.catch) played.catch(() => {});
            } else {
              this.video.pause();
            }
          });
        }

        if (this.muteButton) {
          this.muteButton.addEventListener('click', () => {
            if (!this.video) return;
            const muted = !this.video.muted;
            this.players.forEach((player) => {
              player.muted = muted;
              if (!muted && player.volume === 0) player.volume = 1;
            });
          });
        }

        if (this.volumeInput) {
          this.volumeInput.addEventListener('input', () => {
            const value = parseFloat(this.volumeInput.value);
            this.players.forEach((player) => {
              player.volume = value;
              player.muted = value === 0;
            });
          });
        }

        this.bindScrubber();
        this.loadPart(this.players[0], 0, 'auto');
        if (this.parts[1] && this.players[1]) this.loadPart(this.players[1], 1, 'metadata');
        this.syncPlayState();
        this.syncVolumeState();
        this.renderProgress();
      }

      /* ---------- one continuous timeline across the uploaded parts ---------- */

      measureTimeline() {
        this.offsets = [];
        let running = 0;
        this.parts.forEach((part) => {
          this.offsets.push(running);
          running += Math.max(0, part.duration || 0);
        });
        this.total = running;
        if (this.durationLabel) this.durationLabel.textContent = this.formatTime(this.total);
        if (this.progress) this.progress.setAttribute('aria-valuemax', Math.floor(this.total));
      }

      formatTime(seconds) {
        if (!isFinite(seconds) || seconds < 0) seconds = 0;
        const whole = Math.floor(seconds);
        const hours = Math.floor(whole / 3600);
        const minutes = Math.floor((whole % 3600) / 60);
        const secs = whole % 60;
        const pad = (value) => (value < 10 ? '0' + value : String(value));
        return hours ? hours + ':' + pad(minutes) + ':' + pad(secs) : minutes + ':' + pad(secs);
      }

      globalTime() {
        if (!this.video) return 0;
        let local = this.video.currentTime || 0;
        const duration = this.video.duration;
        if (isFinite(duration) && duration > 0) local = Math.min(local, duration);
        return (this.offsets[this.index] || 0) + local;
      }

      partAt(time) {
        for (let i = this.parts.length - 1; i >= 0; i -= 1) {
          if (time >= this.offsets[i]) return i;
        }
        return 0;
      }

      loadPart(player, index, preload) {
        if (!player || !this.parts[index]) return;
        if (player.dataset.part === String(index) && player.src) return;
        player.dataset.part = String(index);
        player.preload = preload || 'auto';
        player.src = this.parts[index].src;
        player.muted = this.video ? this.video.muted : false;
        player.volume = this.video ? this.video.volume : 1;
        player.load();
      }

      seekPlayer(player, time) {
        const apply = () => { try { player.currentTime = time; } catch (error) {} };
        if (player.readyState >= 1) apply();
        else player.addEventListener('loadedmetadata', apply, { once: true });
      }

      // Warm the off-screen player with the next part so the handoff is instant.
      stageNext() {
        if (this.staged) return;
        const next = this.index + 1;
        if (next >= this.parts.length || this.players.length < 2) return;
        this.staged = true;
        const idle = this.players[1 - this.active];
        this.loadPart(idle, next, 'auto');
        this.seekPlayer(idle, 0);
      }

      /* Autoplay policy is per-element, so give the off-screen player its
         permission inside the same user gesture that opens the modal. */
      prime() {
        if (this.primed || this.players.length < 2) return;
        this.primed = true;
        const idle = this.players[1 - this.active];
        if (!idle.src) return;
        const wasMuted = idle.muted;
        idle.muted = true;
        const played = idle.play();
        if (played && played.then) {
          played.then(() => {
            idle.pause();
            try { idle.currentTime = 0; } catch (error) {}
            idle.muted = wasMuted;
          }).catch(() => { idle.muted = wasMuted; });
        }
      }

      activate(player, index, time) {
        const previous = this.video;
        player.muted = previous.muted;
        player.volume = previous.volume;
        if (time != null) this.seekPlayer(player, time);
        player.classList.add('is-active');
        previous.classList.remove('is-active');
        // reassign before pausing, so the old player's pause event is ignored
        this.video = player;
        this.active = this.players.indexOf(player);
        this.index = index;
        this.staged = false;
        previous.pause();
      }

      // Part finished — swap to the pre-buffered player. No black frame, no reload.
      advance() {
        const next = this.index + 1;
        if (next >= this.parts.length) {
          this.syncPlayState();
          this.renderProgress();
          return;
        }
        const idle = this.players[1 - this.active];
        const ready = idle && idle.dataset.part === String(next) && idle.readyState >= 2;
        if (ready) {
          this.activate(idle, next, null);
          const played = this.video.play();
          if (played && played.catch) played.catch(() => this.jumpTo(next, 0, true));
          this.syncPlayState();
        } else {
          this.jumpTo(next, 0, true);
        }
      }

      // Used when scrubbing across a boundary, and as the fallback handoff path.
      jumpTo(index, time, resume) {
        const idle = this.players.length > 1 ? this.players[1 - this.active] : this.video;
        const wasPlaying = resume != null ? resume : !this.video.paused;
        if (idle === this.video) {
          this.loadPart(idle, index, 'auto');
          this.index = index;
          this.staged = false;
          this.seekPlayer(idle, time);
          if (wasPlaying) { const played = idle.play(); if (played && played.catch) played.catch(() => {}); }
          this.syncPlayState();
          return;
        }
        this.loadPart(idle, index, 'auto');
        const go = () => {
          this.activate(idle, index, time);
          if (wasPlaying) { const played = idle.play(); if (played && played.catch) played.catch(() => {}); }
          this.syncPlayState();
          this.renderProgress();
        };
        if (idle.readyState >= 1) go();
        else idle.addEventListener('loadedmetadata', go, { once: true });
      }

      seekGlobal(time) {
        time = Math.max(0, Math.min(time, Math.max(0, this.total - 0.05)));
        const index = this.partAt(time);
        const local = time - this.offsets[index];
        if (index === this.index) this.seekPlayer(this.video, local);
        else this.jumpTo(index, local, null);
        this.renderProgress(time);
      }

      renderProgress(forced) {
        if (!this.progress) return;
        const time = forced != null ? forced : this.globalTime();
        const percent = this.total ? Math.min(100, (time / this.total) * 100) : 0;
        if (this.fillBar) this.fillBar.style.width = percent + '%';
        if (this.knob) this.knob.style.left = percent + '%';
        if (this.currentLabel) this.currentLabel.textContent = this.formatTime(time);
        this.progress.setAttribute('aria-valuenow', Math.floor(time));
        this.progress.setAttribute('aria-valuetext', this.formatTime(time) + ' of ' + this.formatTime(this.total));

        if (!this.bufferBar) return;
        let buffered = this.video.currentTime || 0;
        try {
          for (let i = 0; i < this.video.buffered.length; i += 1) {
            if (this.video.buffered.start(i) <= this.video.currentTime + 0.1) {
              buffered = Math.max(buffered, this.video.buffered.end(i));
            }
          }
        } catch (error) {}
        let bufferedGlobal = (this.offsets[this.index] || 0) + buffered;
        if (this.staged) bufferedGlobal = Math.max(bufferedGlobal, this.offsets[Math.min(this.index + 1, this.parts.length - 1)]);
        this.bufferBar.style.width = (this.total ? Math.min(100, (bufferedGlobal / this.total) * 100) : 0) + '%';
      }

      bindScrubber() {
        if (!this.progress) return;
        const track = this.progress.querySelector('.hp-hero__progress-track');
        const timeFromX = (clientX) => {
          const rect = (track || this.progress).getBoundingClientRect();
          const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / Math.max(1, rect.width)));
          return ratio * this.total;
        };

        this.progress.addEventListener('pointerdown', (event) => {
          event.preventDefault();
          this.scrubbing = true;
          this.resumeAfterScrub = !this.video.paused;
          this.pendingSeek = timeFromX(event.clientX);
          this.progress.classList.add('is-scrubbing');
          this.progress.setPointerCapture(event.pointerId);
          this.renderProgress(this.pendingSeek);
        });

        this.progress.addEventListener('pointermove', (event) => {
          if (!this.scrubbing) return;
          this.pendingSeek = timeFromX(event.clientX);
          this.renderProgress(this.pendingSeek);
        });

        const endScrub = () => {
          if (!this.scrubbing) return;
          this.scrubbing = false;
          this.progress.classList.remove('is-scrubbing');
          this.seekGlobal(this.pendingSeek);
          if (this.resumeAfterScrub) {
            const played = this.video.play();
            if (played && played.catch) played.catch(() => {});
          }
        };
        this.progress.addEventListener('pointerup', endScrub);
        this.progress.addEventListener('pointercancel', endScrub);

        this.progress.addEventListener('keydown', (event) => {
          const step = event.shiftKey ? 30 : 5;
          if (event.key === 'ArrowRight') { this.seekGlobal(this.globalTime() + step); event.preventDefault(); }
          else if (event.key === 'ArrowLeft') { this.seekGlobal(this.globalTime() - step); event.preventDefault(); }
          else if (event.key === 'Home') { this.seekGlobal(0); event.preventDefault(); }
          else if (event.key === 'End') { this.seekGlobal(this.total - 1); event.preventDefault(); }
        });
      }

      // Back to part one, frame zero.
      rewindAll() {
        const first = this.players[0];
        if (this.video !== first) {
          first.classList.add('is-active');
          this.video.classList.remove('is-active');
          this.video.pause();
          this.video = first;
          this.active = 0;
        }
        this.index = 0;
        this.staged = false;
        this.loadPart(first, 0, 'auto');
        this.seekPlayer(first, 0);
        if (this.players[1] && this.parts[1]) this.loadPart(this.players[1], 1, 'metadata');
        this.renderProgress(0);
      }

      open(trigger) {
        if (!this.overlay || !this.video) return;
        this.lastFocused = trigger || document.activeElement;
        if (this.hideTimer) window.clearTimeout(this.hideTimer);
        if (this.overlay.parentNode !== document.body) document.body.appendChild(this.overlay);
        this.overlay.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', this.handleKeydown);
        window.requestAnimationFrame(() => this.overlay.classList.add('is-open'));
        this.rewindAll();
        this.prime();
        const played = this.video.play();
        if (played && played.catch) played.catch(() => {});
        if (this.closeButton) this.closeButton.focus({ preventScroll: true });
      }

      close() {
        if (!this.overlay || this.overlay.hidden) return;
        this.overlay.classList.remove('is-open');
        this.players.forEach((player) => player.pause());
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.handleKeydown);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hideTimer = window.setTimeout(() => {
          this.overlay.hidden = true;
        }, reduced ? 200 : 320);
        if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus({ preventScroll: true });
      }

      syncPlayState() {
        if (!this.toggleButton || !this.video) return;
        const playing = !this.video.paused && !this.video.ended;
        this.toggleButton.dataset.state = playing ? 'playing' : 'paused';
        this.toggleButton.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      }

      syncVolumeState() {
        if (!this.video) return;
        const muted = this.video.muted || this.video.volume === 0;
        if (this.muteButton) {
          this.muteButton.dataset.state = muted ? 'off' : 'on';
          this.muteButton.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
        }
        if (this.volumeInput) {
          const value = muted ? 0 : this.video.volume;
          this.volumeInput.value = value;
          this.volumeInput.style.setProperty('--vol', (value * 100) + '%');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-how-it-works]');
    root?.querySelectorAll('.siblings-lp__button[href^="#"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = document.querySelector(button.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lwk-buybox"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBB(root) {
    if (root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    var tabs = root.querySelectorAll('.bb-tab');
    var grids = root.querySelectorAll('.bb-grid');
    var note = root.querySelector('.bb-note');
    var atc = root.querySelector('.bb-atc');
    var looxWraps = root.querySelectorAll('.bb-loox');
    var ratingEl = root.querySelector('.bb-rating');
    if (ratingEl) {
      var scrollToReviews = function () {
        var target = document.querySelector('#looxReviews, .loox-reviews-default, [data-loox-reviews]');
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      };
      ratingEl.addEventListener('click', scrollToReviews);
      ratingEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToReviews(); }
      });
    }

    function selectOption(opt) {
      if (!opt) return;
      var grid = opt.closest('.bb-grid');
      if (grid) {
        var opts = grid.querySelectorAll('.bb-opt');
        for (var i = 0; i < opts.length; i++) {
          opts[i].classList.remove('is-selected');
          opts[i].setAttribute('aria-pressed', 'false');
        }
      }
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');

      var n = opt.getAttribute('data-note') || '';
      if (note) {
        if (n) { note.textContent = n; note.hidden = false; }
        else { note.hidden = true; note.textContent = ''; }
      }

      var oid = opt.getAttribute('data-option');
      for (var j = 0; j < looxWraps.length; j++) {
        looxWraps[j].hidden = (looxWraps[j].getAttribute('data-loox-option') !== oid);
      }

      if (atc) {
        atc.setAttribute('data-variant', opt.getAttribute('data-variant') || '');
        atc.setAttribute('data-selling-plan', opt.getAttribute('data-selling-plan') || '');
      }
    }

    var allOpts = root.querySelectorAll('.bb-opt');
    for (var a = 0; a < allOpts.length; a++) {
      (function (o) { o.addEventListener('click', function () { selectOption(o); }); })(allOpts[a]);
    }

    function activateTab(name) {
      for (var t = 0; t < tabs.length; t++) {
        var on = tabs[t].getAttribute('data-tab') === name;
        tabs[t].classList.toggle('is-active', on);
        tabs[t].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      for (var g = 0; g < grids.length; g++) {
        grids[g].hidden = (grids[g].getAttribute('data-grid') !== name);
      }
      var oneTime = (name === 'onetime');
      var payLabel = root.querySelector('.bb-pay-label');
      if (payLabel) { payLabel.style.display = oneTime ? 'none' : ''; }
      var chips = root.querySelector('.bb-chips');
      if (chips) { chips.style.display = oneTime ? 'none' : ''; }
      var activeGrid = root.querySelector('.bb-grid[data-grid="' + name + '"]');
      if (activeGrid) {
        var sel = activeGrid.querySelector('.bb-opt.is-selected') || activeGrid.querySelector('.bb-opt');
        selectOption(sel);
      }
    }
    for (var tb = 0; tb < tabs.length; tb++) {
      (function (t) { t.addEventListener('click', function () { activateTab(t.getAttribute('data-tab')); }); })(tabs[tb]);
    }

    var initTab = root.querySelector('.bb-tab.is-active') || tabs[0];
    if (initTab) { activateTab(initTab.getAttribute('data-tab')); }

    if (atc) {
      atc.addEventListener('click', function () {
        var vid = atc.getAttribute('data-variant');
        if (!vid) { return; }
        atc.disabled = true;
        var line = { id: parseInt(vid, 10), quantity: 1 };
        var sp = atc.getAttribute('data-selling-plan');
        if (sp) { line.selling_plan = parseInt(sp, 10); }
        fetch(atc.getAttribute('data-cart-add') || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [line] })
        }).then(function (r) { return r.json(); }).then(function () {
          window.location.href = atc.getAttribute('data-cart-url') || '/cart';
        }).catch(function () { atc.disabled = false; });
      });
    }

    var featTabs = root.querySelectorAll('.bb-feattab');
    var featPanels = root.querySelectorAll('.bb-feat-panel');
    if (featTabs.length) {
      function showFeat(id) {
        for (var i = 0; i < featTabs.length; i++) {
          var on = featTabs[i].getAttribute('data-feattab') === id;
          featTabs[i].classList.toggle('is-active', on);
          featTabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var j = 0; j < featPanels.length; j++) {
          featPanels[j].hidden = featPanels[j].getAttribute('data-featpanel') !== id;
        }
      }
      for (var f = 0; f < featTabs.length; f++) {
        (function (t) { t.addEventListener('click', function () { showFeat(t.getAttribute('data-feattab')); }); })(featTabs[f]);
      }
    }

    var stage = root.querySelector('.bb-stage');
    if (stage) {
      var slides = stage.querySelectorAll('.bb-slide');
      var thumbs = root.querySelectorAll('.bb-thumb');
      function setActiveThumb(idx) {
        for (var i = 0; i < thumbs.length; i++) { thumbs[i].classList.toggle('is-active', i === idx); }
      }
      for (var th = 0; th < thumbs.length; th++) {
        (function (i) {
          thumbs[i].addEventListener('click', function () {
            if (slides[i]) { stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
            setActiveThumb(i);
          });
        })(th);
      }
      if ('IntersectionObserver' in window && slides.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var idx = Array.prototype.indexOf.call(slides, e.target);
              if (idx > -1) setActiveThumb(idx);
            }
          });
        }, { root: stage, threshold: 0.6 });
        for (var s = 0; s < slides.length; s++) { io.observe(slides[s]); }
      }
      setActiveThumb(0);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.lwk-bb');
    for (var i = 0; i < roots.length; i++) { initBB(roots[i]); }
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.lwk-bb') : null;
    if (r) { r.dataset.bbInit = ''; initBB(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lwk-buyboxOTP"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBB(root) {
    if (root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    var note = root.querySelector('.bb-note');
    var atcButtons = root.querySelectorAll('.bb-atc');
    var ratingEl = root.querySelector('.bb-rating');
    if (ratingEl) {
      var scrollToReviews = function () {
        var target = document.querySelector('#looxReviews, .loox-reviews-default, [data-loox-reviews]');
        if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      };
      ratingEl.addEventListener('click', scrollToReviews);
      ratingEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scrollToReviews(); }
      });
    }

    function selectOption(opt) {
      if (!opt) return;
      var grid = opt.closest('.bb-grid');
      if (grid) {
        var opts = grid.querySelectorAll('.bb-opt');
        for (var i = 0; i < opts.length; i++) {
          opts[i].classList.remove('is-selected');
          opts[i].setAttribute('aria-pressed', 'false');
        }
      }
      opt.classList.add('is-selected');
      opt.setAttribute('aria-pressed', 'true');

      var n = opt.getAttribute('data-note') || '';
      if (note) {
        if (n) { note.textContent = n; note.hidden = false; }
        else { note.hidden = true; note.textContent = ''; }
      }

      for (var ai = 0; ai < atcButtons.length; ai++) {
        atcButtons[ai].setAttribute('data-variant', opt.getAttribute('data-variant') || '');
        atcButtons[ai].setAttribute('data-selling-plan', opt.getAttribute('data-selling-plan') || '');
      }
    }

    var allOpts = root.querySelectorAll('.bb-opt');
    for (var a = 0; a < allOpts.length; a++) {
      (function (o) { o.addEventListener('click', function () { selectOption(o); }); })(allOpts[a]);
    }

    var initSel = root.querySelector('.bb-opt.is-selected') || root.querySelector('.bb-opt');
    selectOption(initSel);

    function addToCart(btn) {
      var vid = btn.getAttribute('data-variant');
      if (!vid) { return; }
      btn.disabled = true;
      var line = { id: parseInt(vid, 10), quantity: 1 };
      var sp = btn.getAttribute('data-selling-plan');
      if (sp) { line.selling_plan = parseInt(sp, 10); }
      fetch(btn.getAttribute('data-cart-add') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = btn.getAttribute('data-cart-url') || '/cart';
      }).catch(function () { btn.disabled = false; });
    }

    for (var ab = 0; ab < atcButtons.length; ab++) {
      (function (btn) { btn.addEventListener('click', function () { addToCart(btn); }); })(atcButtons[ab]);
    }

    var otpButtons = root.querySelectorAll('.bb-otp');
    for (var ob = 0; ob < otpButtons.length; ob++) {
      (function (btn) { btn.addEventListener('click', function () { addToCart(btn); }); })(otpButtons[ob]);
    }

    var featTabs = root.querySelectorAll('.bb-feattab');
    var featPanels = root.querySelectorAll('.bb-feat-panel');
    if (featTabs.length) {
      function showFeat(id) {
        for (var i = 0; i < featTabs.length; i++) {
          var on = featTabs[i].getAttribute('data-feattab') === id;
          featTabs[i].classList.toggle('is-active', on);
          featTabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        for (var j = 0; j < featPanels.length; j++) {
          featPanels[j].hidden = featPanels[j].getAttribute('data-featpanel') !== id;
        }
      }
      for (var f = 0; f < featTabs.length; f++) {
        (function (t) { t.addEventListener('click', function () { showFeat(t.getAttribute('data-feattab')); }); })(featTabs[f]);
      }
    }

    var stage = root.querySelector('.bb-stage');
    if (stage) {
      var slides = stage.querySelectorAll('.bb-slide');
      var thumbs = root.querySelectorAll('.bb-thumb');
      function setActiveThumb(idx) {
        for (var i = 0; i < thumbs.length; i++) { thumbs[i].classList.toggle('is-active', i === idx); }
      }
      for (var th = 0; th < thumbs.length; th++) {
        (function (i) {
          thumbs[i].addEventListener('click', function () {
            if (slides[i]) { stage.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); }
            setActiveThumb(i);
          });
        })(th);
      }
      if ('IntersectionObserver' in window && slides.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var idx = Array.prototype.indexOf.call(slides, e.target);
              if (idx > -1) setActiveThumb(idx);
            }
          });
        }, { root: stage, threshold: 0.6 });
        for (var s = 0; s < slides.length; s++) { io.observe(slides[s]); }
      }
      setActiveThumb(0);
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('.lwk-bb');
    for (var i = 0; i < roots.length; i++) { initBB(roots[i]); }
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.lwk-bb') : null;
    if (r) { r.dataset.bbInit = ''; initBB(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lwk-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SPEED = 70;
  function initMarquee(root) {
    var track = root.querySelector('.mq-track');
    var group = root.querySelector('.mq-group');
    if (!track || !group) return;
    function setDuration() {
      var w = group.offsetWidth;
      if (w > 0) { track.style.animationDuration = (w / SPEED) + 's'; }
    }
    setDuration();
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(setDuration);
      ro.observe(group);
    } else {
      window.addEventListener('resize', setDuration);
    }
  }
  function initAll() {
    var roots = document.querySelectorAll('.lwk-marquee');
    for (var i = 0; i < roots.length; i++) { initMarquee(roots[i]); }
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('.lwk-marquee') : null;
    if (r) { initMarquee(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-kelsey"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-meet-kelsey]');
    root?.querySelectorAll('.siblings-lp__button[href^="#"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = document.querySelector(button.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Build request URL
  var requestUrl = productRecommendationsSection.dataset.url;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

      theme.peekCarousel.init(
        productRecommendationsSection,
        $('.js-related-product-carousel', productRecommendationsSection),
        '.productRecommendations',
        function() {
          return $(window).width() < 768
        },
        false
      );
    }
  };
  request.send();
};
// Reload the section in the editor when a setting changes
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
document.addEventListener("shopify:section:unload", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    theme.peekCarousel.destroy(
      $('.product-recommendations', event.target),
      $('.js-related-product-carousel', event.target),
      '.productRecommendations'
    );
  }
});
// Fetching the recommendations on page load
document.addEventListener("DOMContentLoaded", function(event) {
  loadProductRecommendationsIntoSection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-reviews]');
    root?.querySelectorAll('.siblings-lp__button[href^="#"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = document.querySelector(button.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seamless-multi-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('seamless-video')) return;

  var RATES = [1, 1.25, 1.5, 1.75, 2, 0.75];

  function fmt(t, long) {
    if (!isFinite(t) || t < 0) t = 0;
    t = Math.floor(t);
    var h = Math.floor(t / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
    return (h || long) ? h + ':' + pad(m) + ':' + pad(s) : m + ':' + pad(s);
  }

  class SeamlessVideo extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;

      var json = this.querySelector('[data-sv-segments]');
      try { this.segs = JSON.parse(json.textContent); } catch (e) { this.segs = []; }
      if (!this.segs.length) return;

      this.q = this.querySelector.bind(this);
      this.stage = this.q('.sv__stage');
      this.a = this.q('[data-sv-a]');
      this.b = this.q('[data-sv-b]');
      this.els = [this.a, this.b];
      this.act = 0;          // index into this.els of the visible element
      this.i = 0;            // current segment index
      this.rateIdx = 0;
      this.started = false;
      this.wantPlaying = false;
      this.dragging = false;
      this.primed = false;

      this.loopAll = this.dataset.loop === 'true';
      this.lead = parseFloat(this.dataset.preloadLead || '25');

      this.computeOffsets();
      this.bind();

      // Segment 0 in element A, segment 1 staged in element B from the start so
      // the very first join is instant and B is unlockable on the first gesture.
      this.assign(this.a, 0, 'auto');
      if (this.segs[1]) this.assign(this.b, 1, 'metadata');

      this.setMuted(this.dataset.muted === 'true');
      this.renderTotal();
      this.measureMissing();

      if (this.dataset.autoplay === 'true') {
        this.setMuted(true);
        this.play();
      }
    }

    disconnectedCallback() { this.els && this.els.forEach(function (v) { v.pause(); }); }

    /* ---------- timeline math ---------- */

    computeOffsets() {
      this.offsets = [];
      var t = 0;
      for (var k = 0; k < this.segs.length; k++) {
        this.offsets.push(t);
        t += Math.max(0, this.segs[k].duration || 0);
      }
      this.total = t;
    }

    segAt(g) {
      for (var k = this.segs.length - 1; k >= 0; k--) if (g >= this.offsets[k]) return k;
      return 0;
    }

    get el() { return this.els[this.act]; }
    get idle() { return this.els[1 - this.act]; }

    globalTime() {
      var d = this.el.duration;
      var local = this.el.currentTime || 0;
      if (isFinite(d) && d > 0) local = Math.min(local, d);
      return this.offsets[this.i] + local;
    }

    /* Liquid gives us durations up front, but if a source lacks one we read it
       from metadata so the unified bar stays honest. */
    measureMissing() {
      var self = this;
      var missing = this.segs.map(function (s, k) { return s.duration > 0 ? -1 : k; }).filter(function (k) { return k >= 0; });
      if (!missing.length) return;
      var probe = document.createElement('video');
      probe.preload = 'metadata';
      probe.muted = true;
      var next = function () {
        if (!missing.length) { probe.removeAttribute('src'); self.computeOffsets(); self.renderTotal(); self.tick(); return; }
        var k = missing.shift();
        probe.onloadedmetadata = function () { self.segs[k].duration = probe.duration || 0; next(); };
        probe.onerror = next;
        probe.src = self.segs[k].src;
      };
      next();
    }

    /* ---------- element plumbing ---------- */

    assign(el, index, preload) {
      if (el.dataset.seg === String(index) && el.src) return;
      el.dataset.seg = String(index);
      el.preload = preload || 'auto';
      el.src = this.segs[index].src;
      el.playbackRate = RATES[this.rateIdx];
      el.volume = this.volume == null ? 1 : this.volume;
      el.muted = !!this.muted;
      el.load();
    }

    /* Fire once inside the first real user gesture: gives element B playback
       permission so the mid-sequence handoff is never blocked by autoplay policy. */
    prime() {
      if (this.primed) return;
      this.primed = true;
      var el = this.idle;
      if (!el.src) return;
      var wasMuted = el.muted;
      el.muted = true;
      var p = el.play();
      if (p && p.then) p.then(function () { el.pause(); try { el.currentTime = 0; } catch (e) {} el.muted = wasMuted; })
        .catch(function () { el.muted = wasMuted; });
    }

    /* ---------- transport ---------- */

    play() {
      this.wantPlaying = true;
      this.started = true;
      this.classList.add('is-started');
      var self = this;
      var p = this.el.play();
      if (p && p.catch) p.catch(function () { self.wantPlaying = false; self.sync(); });
      this.stage.focus({ preventScroll: true });
    }

    pause() { this.wantPlaying = false; this.el.pause(); }

    toggle() { this.prime(); this.wantPlaying ? this.pause() : this.play(); }

    /* Instant handoff: the idle element already holds segment i+1 decoded at 0. */
    advance() {
      var n = this.i + 1;
      if (n >= this.segs.length) {
        if (this.loopAll) { this.seek(0); this.play(); }
        else { this.wantPlaying = false; this.sync(); }
        return;
      }
      var nxt = this.idle;
      if (nxt.dataset.seg === String(n) && nxt.readyState >= 2) {
        var old = this.el;
        this.act = 1 - this.act;
        this.i = n;
        nxt.playbackRate = RATES[this.rateIdx];
        nxt.volume = this.volume;
        nxt.muted = this.muted;
        nxt.classList.add('is-active');
        old.classList.remove('is-active');
        old.pause();
        var self = this;
        var p = nxt.play();
        if (p && p.catch) p.catch(function () { self.hardSwitch(n, 0); });
        this.staged = false;
        this.sync();
      } else {
        this.hardSwitch(n, 0);
      }
    }

    /* Used for scrub-across-boundaries and as the fallback path. */
    hardSwitch(index, local) {
      var el = this.idle, old = this.el, self = this;
      this.assign(el, index, 'auto');
      var go = function () {
        try { el.currentTime = local || 0; } catch (e) {}
        el.playbackRate = RATES[self.rateIdx];
        el.volume = self.volume;
        el.muted = self.muted;
        el.classList.add('is-active');
        old.classList.remove('is-active');
        old.pause();
        self.act = 1 - self.act;
        self.i = index;
        self.staged = false;
        if (self.wantPlaying) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        self.sync();
      };
      if (el.readyState >= 1) go();
      else el.addEventListener('loadedmetadata', go, { once: true });
    }

    seek(g) {
      g = Math.max(0, Math.min(g, Math.max(0, this.total - 0.05)));
      var k = this.segAt(g);
      var local = g - this.offsets[k];
      if (k === this.i) { try { this.el.currentTime = local; } catch (e) {} }
      else this.hardSwitch(k, local);
      this.tick(g);
    }

    /* Warm the idle element with the next segment before we need it. */
    stageNext() {
      if (this.staged) return;
      var n = this.i + 1;
      if (n >= this.segs.length) return;
      var el = this.idle;
      this.staged = true;
      this.assign(el, n, 'auto');
      var seek0 = function () { try { if (el.currentTime > 0.01) el.currentTime = 0; } catch (e) {} };
      if (el.readyState >= 1) seek0(); else el.addEventListener('loadedmetadata', seek0, { once: true });
    }

    setMuted(m) {
      this.muted = !!m;
      this.els.forEach(function (v) { v.muted = !!m; });
      this.q('[data-sv-mute] .sv__i-on').hidden = !!m;
      this.q('[data-sv-mute] .sv__i-off').hidden = !m;
      this.q('[data-sv-mute]').setAttribute('aria-label', m ? 'Unmute' : 'Mute');
    }

    setVolume(v) {
      this.volume = v;
      this.els.forEach(function (el) { el.volume = v; });
      var r = this.q('[data-sv-volume]');
      if (r && r.value != v) r.value = v;
      if (v === 0 && !this.muted) this.setMuted(true);
      if (v > 0 && this.muted) this.setMuted(false);
    }

    /* ---------- rendering ---------- */

    renderTotal() {
      this.q('[data-sv-dur]').textContent = fmt(this.total);
      var t = this.q('[data-sv-ticks]');
      if (t) {
        var html = '';
        for (var k = 1; k < this.segs.length; k++) html += '<i style="left:' + (this.offsets[k] / this.total * 100) + '%"></i>';
        t.innerHTML = html;
      }
      var scrub = this.q('[data-sv-scrub]');
      scrub.setAttribute('aria-valuemax', Math.floor(this.total));
    }

    tick(forced) {
      var g = forced != null ? forced : this.globalTime();
      var pct = this.total ? (g / this.total * 100) : 0;
      this.q('[data-sv-played]').style.width = pct + '%';
      this.q('[data-sv-knob]').style.left = pct + '%';
      this.q('[data-sv-cur]').textContent = fmt(g);
      var scrub = this.q('[data-sv-scrub]');
      scrub.setAttribute('aria-valuenow', Math.floor(g));
      scrub.setAttribute('aria-valuetext', fmt(g) + ' of ' + fmt(this.total));

      var buf = 0, el = this.el;
      try {
        for (var k = 0; k < el.buffered.length; k++) {
          if (el.buffered.start(k) <= el.currentTime + 0.1 && el.buffered.end(k) >= el.currentTime) buf = el.buffered.end(k);
        }
      } catch (e) {}
      var bufG = this.offsets[this.i] + Math.max(buf, el.currentTime || 0);
      if (this.staged) bufG = Math.max(bufG, this.offsets[Math.min(this.i + 1, this.segs.length - 1)]);
      this.q('[data-sv-buffered]').style.width = (this.total ? Math.min(100, bufG / this.total * 100) : 0) + '%';
    }

    sync() {
      this.classList.toggle('is-playing', this.wantPlaying && !this.el.paused);
      this.q('[data-sv-toggle] .sv__i-play').hidden = this.wantPlaying;
      this.q('[data-sv-toggle] .sv__i-pause').hidden = !this.wantPlaying;
      this.q('[data-sv-toggle]').setAttribute('aria-label', this.wantPlaying ? 'Pause' : 'Play');
      this.q('.sv__big').setAttribute('aria-label', this.wantPlaying ? 'Pause video' : 'Play video');
    }

    spin(on) { this.q('.sv__spinner').hidden = !on; }

    /* ---------- events ---------- */

    bind() {
      var self = this;

      this.els.forEach(function (v) {
        v.addEventListener('timeupdate', function () {
          if (v !== self.el || self.dragging) return;
          self.tick();
          var d = v.duration;
          if (isFinite(d) && d - v.currentTime < self.lead) self.stageNext();
        });
        v.addEventListener('ended', function () { if (v === self.el) self.advance(); });
        v.addEventListener('waiting', function () { if (v === self.el && self.wantPlaying) self.spin(true); });
        v.addEventListener('playing', function () { if (v === self.el) { self.spin(false); self.sync(); } });
        v.addEventListener('pause', function () { if (v === self.el) self.sync(); });
        v.addEventListener('loadedmetadata', function () {
          // Trust real metadata over the Liquid value if they disagree meaningfully.
          var k = parseInt(v.dataset.seg, 10);
          if (isFinite(v.duration) && Math.abs((self.segs[k].duration || 0) - v.duration) > 0.5) {
            self.segs[k].duration = v.duration;
            self.computeOffsets();
            self.renderTotal();
          }
        });
      });

      this.q('.sv__big').addEventListener('click', function () { self.toggle(); });
      this.q('[data-sv-toggle]').addEventListener('click', function () { self.toggle(); });
      this.q('[data-sv-mute]').addEventListener('click', function () { self.setMuted(!self.muted); });
      this.q('[data-sv-volume]').addEventListener('input', function (e) { self.setVolume(parseFloat(e.target.value)); });

      this.q('[data-sv-rate]').addEventListener('click', function () {
        self.rateIdx = (self.rateIdx + 1) % RATES.length;
        var r = RATES[self.rateIdx];
        self.els.forEach(function (v) { v.playbackRate = r; });
        self.q('[data-sv-rate]').innerHTML = r + '&times;';
      });

      this.q('[data-sv-fs]').addEventListener('click', function () {
        if (document.fullscreenElement) document.exitFullscreen();
        else if (self.stage.requestFullscreen) self.stage.requestFullscreen();
        else if (self.el.webkitEnterFullscreen) self.el.webkitEnterFullscreen(); // iOS phone
      });
      document.addEventListener('fullscreenchange', function () {
        var on = document.fullscreenElement === self.stage;
        self.q('.sv__i-fs').hidden = on;
        self.q('.sv__i-fsx').hidden = !on;
      });

      // click video body to toggle (ignore clicks on the controls)
      this.stage.addEventListener('click', function (e) {
        if (e.target.closest('.sv__controls') || e.target.closest('.sv__big')) return;
        self.toggle();
      });

      // auto-hide controls
      var hideT;
      var wake = function () {
        self.classList.remove('is-hidden-controls');
        clearTimeout(hideT);
        hideT = setTimeout(function () { if (self.wantPlaying) self.classList.add('is-hidden-controls'); }, 2600);
      };
      ['pointermove', 'pointerdown', 'keydown'].forEach(function (ev) { self.stage.addEventListener(ev, wake); });
      this.stage.addEventListener('pointerleave', function () { if (self.wantPlaying) self.classList.add('is-hidden-controls'); });

      /* scrubbing — all in global time, so dragging across a segment boundary
         just works */
      var scrub = this.q('[data-sv-scrub]');
      var tip = this.q('[data-sv-tip]');
      var posToTime = function (clientX) {
        var r = scrub.getBoundingClientRect();
        return Math.max(0, Math.min(1, (clientX - r.left) / r.width)) * self.total;
      };
      var showTip = function (clientX) {
        var r = scrub.getBoundingClientRect();
        var x = Math.max(0, Math.min(r.width, clientX - r.left));
        tip.hidden = false;
        tip.style.left = x + 'px';
        tip.textContent = fmt(posToTime(clientX));
      };

      scrub.addEventListener('pointermove', function (e) { if (!self.dragging) showTip(e.clientX); });
      scrub.addEventListener('pointerleave', function () { if (!self.dragging) tip.hidden = true; });

      scrub.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        self.dragging = true;
        self.wasPlaying = self.wantPlaying;
        scrub.classList.add('is-drag');
        scrub.setPointerCapture(e.pointerId);
        var g = posToTime(e.clientX);
        self.tick(g); showTip(e.clientX);
        self.pendingSeek = g;
      });
      scrub.addEventListener('pointermove', function (e) {
        if (!self.dragging) return;
        var g = posToTime(e.clientX);
        self.pendingSeek = g;
        self.tick(g); showTip(e.clientX);
      });
      var endDrag = function (e) {
        if (!self.dragging) return;
        self.dragging = false;
        scrub.classList.remove('is-drag');
        tip.hidden = true;
        self.seek(self.pendingSeek);
        if (self.wasPlaying) self.play();
      };
      scrub.addEventListener('pointerup', endDrag);
      scrub.addEventListener('pointercancel', endDrag);

      scrub.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 30 : 5;
        if (e.key === 'ArrowRight') { self.seek(self.globalTime() + step); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { self.seek(self.globalTime() - step); e.preventDefault(); }
        if (e.key === 'Home') { self.seek(0); e.preventDefault(); }
        if (e.key === 'End') { self.seek(self.total - 1); e.preventDefault(); }
      });

      this.stage.addEventListener('keydown', function (e) {
        if (e.target.matches('input,[data-sv-scrub]')) return;
        var k = e.key.toLowerCase();
        if (k === ' ' || k === 'k') { self.toggle(); e.preventDefault(); }
        else if (k === 'arrowright') { self.prime(); self.seek(self.globalTime() + 10); e.preventDefault(); }
        else if (k === 'arrowleft') { self.prime(); self.seek(self.globalTime() - 10); e.preventDefault(); }
        else if (k === 'arrowup') { self.setVolume(Math.min(1, (self.volume || 0) + 0.1)); e.preventDefault(); }
        else if (k === 'arrowdown') { self.setVolume(Math.max(0, (self.volume || 0) - 0.1)); e.preventDefault(); }
        else if (k === 'm') { self.setMuted(!self.muted); }
        else if (k === 'f') { self.q('[data-sv-fs]').click(); }
      });

      // pause when scrolled out of view
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!en.isIntersecting && self.wantPlaying) self.pause(); });
        }, { threshold: 0.15 }).observe(this);
      }

      this.setVolume(1);
      this.sync();
    }
  }

  customElements.define('seamless-video', SeamlessVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["siblings-lp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const siblingsLp = document.querySelector('[data-siblings-lp]');
    siblingsLp?.querySelectorAll('.siblings-lp__button[href^="#"]').forEach((button) => {
      button.addEventListener('click', (event) => {
        const target = document.querySelector(button.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  if (!customElements.get('siblings-bundle-builder')) {
    customElements.define('siblings-bundle-builder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';

        this.cards = [...this.querySelectorAll('[data-bundle-card]')];
        this.currency = this.dataset.currency || window.Shopify?.currency?.active || 'USD';
        this.form = this.querySelector('[data-bundle-form]');
        this.status = this.querySelector('[data-status]');

        this.months = Number(this.dataset.chargeMonths) || 1;
        this.cards.forEach((card) => this.updateCard(card));
        requestAnimationFrame(() => {
          const selectedCard = this.querySelector('[data-bundle-choice]:checked')?.closest('[data-bundle-card]');
          if (selectedCard && window.matchMedia('(max-width: 899px)').matches) {
            selectedCard.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
          }
        });

        this.addEventListener('click', (event) => {
          const card = event.target.closest('[data-bundle-card]');
          if (!card) return;
          if (!event.target.closest('select, button, a')) this.selectCard(card);
        });

        this.addEventListener('change', (event) => {
          const card = event.target.closest('[data-bundle-card]');
          if (!card) return;
          if (event.target.matches('[data-bundle-choice]')) this.selectCard(card);
          if (event.target.matches('[data-product-select]')) this.updateCard(card);
        });

        this.addEventListener('submit', async (event) => {
          event.preventDefault();
          const submittedCard = event.submitter?.closest('[data-bundle-card]');
          if (submittedCard) this.selectCard(submittedCard);
          const card = this.querySelector('[data-bundle-choice]:checked')?.closest('[data-bundle-card]');
          if (!card) return;
          const button = card.querySelector('button[type="submit"]');
          const selects = [...card.querySelectorAll('[data-product-select]')];
          const selections = selects
            .map((select) => ({
              id: Number(select.value),
              sellingPlan: Number(select.selectedOptions[0]?.dataset.sellingPlan) || null
            }))
            .filter((selection) => selection.id);
          if (selections.length !== Number(card.dataset.count)) {
            this.status.textContent = 'Choose an available product for every child.';
            return;
          }
          button.disabled = true;
          this.status.textContent = 'Adding bundle…';
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: selections.map((selection, index) => ({
                  id: selection.id,
                  quantity: 1,
                  ...(selection.sellingPlan ? { selling_plan: selection.sellingPlan } : {}),
                  properties: {
                    '_Sibling bundle size': `${card.dataset.count} boxes`,
                    '_Bundle position': index + 1
                  }
                }))
              })
            });
            if (!response.ok) throw new Error('Cart request failed');
            this.status.textContent = 'Bundle added to cart.';
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            const root = window.Shopify?.routes?.root || '/';
            const cartUrl = window.Shopify?.routes?.cart_url || '/cart';
            const discountCode = card.dataset.discountCode;
            window.location.href = discountCode
              ? `${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(cartUrl)}`
              : cartUrl;
          } catch (error) {
            this.status.textContent = 'Could not add the bundle. Please try again.';
          } finally {
            button.disabled = false;
          }
        });
      }

      selectCard(card) {
        this.cards.forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.querySelector('[data-bundle-choice]').checked = selected;
        });
      }

      updateCard(card) {
        let total = 0;
        let undiscounted = 0;
        card.querySelectorAll('[data-product-select]').forEach((select) => {
          const option = select.selectedOptions[0];
          const basePrice = Number(option?.dataset.price || 0);
          const discount = Number(select.dataset.discount || 0);
          const linePrice = Math.round(basePrice * (100 - discount) / 100);
          undiscounted += basePrice;
          total += linePrice;
          const row = select.closest('.siblings-lp__select-row');
          row.querySelector('[data-line-price]').textContent = this.formatMoney(linePrice);
          const perMonth = row.querySelector('[data-line-per-month]');
          if (perMonth && !perMonth.hidden) {
            perMonth.textContent = `${this.formatMoney(Math.round(linePrice / this.months))}/mo`;
          }
        });
        card.querySelector('[data-total-price]').textContent = this.formatMoney(total);
        const note = card.querySelector('[data-total-note]');
        if (note && !note.hidden) {
          note.textContent = `Works out to ${this.formatMoney(Math.round(total / this.months))}/mo · ships monthly`;
        }
        const saving = card.querySelector('[data-saving]');
        if (saving) {
          const savingAmount = Math.max(0, undiscounted - total);
          saving.hidden = savingAmount === 0;
          saving.querySelector('[data-saving-price]').textContent = this.formatMoney(savingAmount);
        }
      }

      formatMoney(cents) {
        const hasCents = cents % 100 !== 0;
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: hasCents ? 2 : 0,
          maximumFractionDigits: 2
        }).format(cents / 100);
      }
    });
  }

  if (!customElements.get('siblings-faqs')) {
    customElements.define('siblings-faqs', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.querySelectorAll('details').forEach((details) => {
          const summary = details.querySelector('summary');
          const answer = details.querySelector('.siblings-lp__answer');
          summary.addEventListener('click', (event) => {
            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
            event.preventDefault();
            if (details.dataset.animating) return;
            const isOpen = details.open;
            const startHeight = details.offsetHeight;
            if (!isOpen) details.open = true;
            const endHeight = isOpen ? summary.offsetHeight : summary.offsetHeight + answer.offsetHeight;
            details.dataset.animating = 'true';
            details.style.height = `${startHeight}px`;
            const animation = details.animate(
              { height: [`${startHeight}px`, `${endHeight}px`] },
              { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' }
            );
            animation.onfinish = () => {
              if (isOpen) details.open = false;
              details.style.height = '';
              delete details.dataset.animating;
            };
            animation.oncancel = () => {
              details.style.height = '';
              delete details.dataset.animating;
            };
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
